@if (tenantLogoSrc(); as logoSrc) {
  <img
    class="tenant-logo"
    [src]="logoSrc"
    width="200"
    height="80"
  />
} @else {
  <app-skeleton
    height="80px"
    width="80px"
  ></app-skeleton>
}
